import React, { useEffect, useState } from "react";
import axios from "axios";

const gdprCountries = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IS",
  "IE",
  "IT",
  "LV",
  "LI",
  "LT",
  "LU",
  "MT",
  "NL",
  "NO",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  "GB",
];

const ConsentBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (consent) return;

    axios
      .get("https://ipapi.co/json/")
      .then((res) => {
        const country = res.data.country;
        if (gdprCountries.includes(country)) {
          setShowBanner(true);
        }
      })
      .catch((err) => console.error("Geo check failed:", err));
  }, []);

  const acceptAll = () => {
    window.gtag &&
      window.gtag("consent", "update", {
        ad_storage: "granted",
        analytics_storage: "granted",
      });
    localStorage.setItem("cookie_consent", "granted");
    setShowBanner(false);
  };

  const declineAll = () => {
    window.gtag &&
      window.gtag("consent", "update", {
        ad_storage: "denied",
        analytics_storage: "denied",
      });
    localStorage.setItem("cookie_consent", "denied");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div style={styles.banner}>
      <div style={styles.container}>
        <p style={styles.message}>
          ✈️ We use cookies to enhance your Sevenly Travel experience. Accept
          cookies for smoother trip planning and personalized recommendations.
        </p>
        <div style={styles.buttons}>
          <button onClick={acceptAll} style={styles.accept}>
            Accept
          </button>
          <button onClick={declineAll} style={styles.decline}>
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  banner: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    borderTop: "1px solid #ddd",
    boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.05)",
    zIndex: 9999,
    padding: "0.8rem 1rem",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    maxWidth: "1080px",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "0.75rem",
    justifyContent: "center",
  },
  message: {
    flex: "1 1 300px",
    fontSize: "0.9rem",
    fontFamily: '"Plus Jakarta Sans", sans-serif',
    lineHeight: "1.4",
    margin: 0,
    textAlign: "left",
  },
  buttons: {
    display: "flex",
    gap: "0.5rem",
    flexShrink: 0,
  },
  accept: {
    backgroundColor: "#22ccb2",
    color: "#fff",
    border: "none",
    padding: "0.35rem 0.9rem",
    borderRadius: "4px",
    fontSize: "0.85rem",
    fontWeight: 600,
    cursor: "pointer",
    minWidth: "80px",
  },
  decline: {
    backgroundColor: "#e0e0e0",
    color: "#333",
    border: "none",
    padding: "0.35rem 0.9rem",
    borderRadius: "4px",
    fontSize: "0.85rem",
    fontWeight: 600,
    cursor: "pointer",
    minWidth: "80px",
  },
};

export default ConsentBanner;
